import { DashboardWizardV2 } from "app/components/dashboard/widget-wizard/DashboardWizard-v2";
import { useCallback, useEffect } from "react";
import { proNavigator } from "single-spa/react-app/ProNavigator";
import styled from "styled-components";
import DashboardCopyToUserDialog from "./DashboardCopyToUserDialog";
import { trackEvent } from "app/services/AppcuesService";
const DashboardParentContainer = styled.div`
    overflow-y: auto;
    height: 100%;
    overflow-x: hidden;
    flex-grow: 1;
    position: relative;
`;
DashboardParentContainer.displayName = "DashboardParentContainer";

export const DashboardGalleryPageV2 = () => {
    useEffect(() => {
        console.log("DashboardGalleryPageV2 mounted");
        trackEvent("Create NEW dashboard");
        return () => {
            console.log("DashboardGalleryPageV2 unmounted");
        };
    }, []);

    const handleCloseWizard = useCallback(() => {
        proNavigator.go("dashboard");
    }, []);

    return (
        <div className={"innerWrap dashboard-wrap dashboard-wrap-no-header"}>
            <div className="react-wizard-wrap">
                <DashboardCopyToUserDialog />
                <DashboardWizardV2
                    selectedWidget={null}
                    onClose={handleCloseWizard}
                />
            </div>
        </div>
    );
};
